import React from 'react';
import PropTypes from 'prop-types';
import Card, {CardHeader} from "UI/Card";
import Skeleton from "UI/Skeleton";

export default class StoryListItemSkeleton extends React.Component
{
    render()
    {
        const header = <CardHeader
            title={<Skeleton className='h-7 w-24 rounded' />}
            description={<Skeleton className='h-4 w-16 rounded' />}
            action={<Skeleton className='h-6 w-6 rounded' />}
        />;

        return <Card header={header}>
            <Skeleton className='h-4 w-36 rounded' />
        </Card>;
    }
}